<template>
   <div class="content">
        <!-- 查询和其他操作 -->
        <Form ref="formValidate" :model="listQuery" :label-width="80">
            <Row>
                <Col span="4">
                    <FormItem label="选择门店" class="mb-10" style="95%">
                        <Select v-model="listQuery.store_id"   placeholder="请选择门店">
                            <Option v-for="item in storeList" :key="item.id" :value="item.id">{{item.name}}</Option>
                        </Select>
                    </FormItem>
                </Col>
                <Col span="4">
                    <FormItem label="选择月份" class="mb-10" style="95%">
                        <DatePicker type="month" placeholder="请选择日期" 
                            format="yyyy-MM" 
                            v-model="listQuery.month"  
                        ></DatePicker>
                    </FormItem>
                </Col>
                <Col span="16" >
                    <FormItem :label-width="0" class="mb-10" style="margin-left:10px">
                        <Button   type="primary" icon="ios-search" @click="getList">查询</Button>
                        <Button  type="primary" icon="ios-search" @click="emptyFilter">清空筛选</Button>
                        <Button  width="100%" icon="ios-arrow-round-down" type="primary" 
                        :loading="downloadLoading" @click="downloadCurrentExcel"
                        >下载当前模板</Button>
                        <Upload 
                            style="display: inline-block"
                            ref="upload"
                            :action="uploadUrl" 
                            :data="CurrentUploadParams"
                            :headers="uploadHeaders"
                            name="excel"
                            :show-upload-list="false"
                            :on-format-error="handleFormatError"
                            :on-success="handleSuccess"
                            :on-error="handleError"
                            :format ="['xlsx','xls']">
                            <Button  width="100%" icon="ios-arrow-round-up" type="primary">导入Excel</Button>
                        </Upload>

                    </FormItem>
                    
                </Col>
            </Row>
        </Form>
        <div class="table_wrap">
            <div style="margin:10px 0px">班次说明：
                <Tag color="success">A：9：00-17：00</Tag>
                <Tag color="success">B：12：00-22：00</Tag>
                <Tag color="success">C：9：00-22：00</Tag>
                <Tag color="success">休：休息</Tag>
            </div>
            <div style="width:100%">
                <Table id="tab"  ref="table" stripe border  
                    :height="tableHeight" 
                    :loading="tabLoading" 
                    :columns="tabColumns" 
                    :data="tabData"></Table>
            </div>
           
            <!-- <div style="margin-top:20px;display:flex;justify-content:flex-end">
                <Page show-total show-elevator show-sizer  :page-size-opts="pageSizeOpts" 
                    :total="total"  :current="listQuery.page"
                    @on-change="changePage" 
                    @on-page-size-change="changeLimit"/>
            </div> -->
        </div>
        <!-- 编辑排班对话框 -->
        <Modal
            v-model="showAddScheduling"
            :closable="true"
            :mask-closable="true"
            :footer-hide="true"
            width="320"
            class-name="vertical-center-modal">
                <Row>
                    <Col span="24">
                        <span class="edit_scheduling_text">{{addSchedulingForm.name}}</span>
                        <span class="edit_scheduling_text">{{addSchedulingForm.date}}</span>
                    </Col>
                    <Col span="24">
                        <Col span="4" class="edit_scheduling_text"><div>班次</div> </Col>
                        <Col span="20" class="edit_scheduling_text">
                            <RadioGroup  @on-change="editData" v-model="addSchedulingForm.schedule_type"  style="width:90%"  size="small"  type="button">
                                <Radio  label='A'>A</Radio>
                                <Radio  label='B'>B</Radio>
                                <Radio  label='C'>C</Radio>
                                <Radio  label='休'>休</Radio>
                            </RadioGroup>
                        </Col>
                    </Col>
                </Row>
        </Modal>

        <!-- 编辑权重对话框 -->
        <Modal
            v-model="showAddSchedulingWeight"
            :closable="true"
            :mask-closable="true"
            :footer-hide="true"
            width="320"
            class-name="vertical-center-modal">
                <Row>
                    <Col span="24">
                        <span class="edit_scheduling_text">{{addSchedulingWeightForm.name}}</span>
                        <span class="edit_scheduling_text">{{addSchedulingWeightForm.date}}</span>
                    </Col>
                    <Col span="24">
                        <Col span="4" class="edit_scheduling_text" style="margin-top:16px"><div>权重</div> </Col>
                        <Col span="20" class="edit_scheduling_text">
                            <i-input 
                                style="width: 90%"
                                ref="weightInput"
                                v-model="addSchedulingWeightForm.weight" 
                                @on-enter="editWeight"
                                placeholder="请输入" 
                            ></i-input>
                        </Col>
                    </Col>
                </Row>
        </Modal>
    </div>
</template>
<script>
var date=new Date;
var year=date.getFullYear(); 
var month=date.getMonth()+1;
month =(month<10 ? "0"+month:month); 
var CurrentDate = (year.toString()+'-'+month.toString());
var CurrentStoreId = null;
var CurrentStoreName = [];
export default {
    name:'maternalConsultantSetting',
    data(){
         return{
            tableHeight: 650,
            storeList:[],
            showAddScheduling:false,  
            showAddSchedulingWeight:false,
            tabLoading:false,
            downloadLoading:false,
            tabData:[],
            tabColumns: [],
            tabExcelArr:[],
            uploadHeaders:{
                Authorization:''
            },
            CurrentUploadParams:{},
            uploadUrl:api.crmScheduleImport,
            // 列表查询参数
            listQuery:{
                // page:1,
                // limit:10,
                store_id:'',
                month:CurrentDate  
            },
            total:0,
            pageSizeOpts:[10,20,30,40,50,100],
            styles: {
                height: 'calc(100% - 55px)',
                overflow: 'auto',
                paddingBottom: '53px',
                position: 'static'
            },
            stylesModal:{
                height: '500px',
                overflow: 'auto',
                // position: 'static'
            },
            addSchedulingForm:{
                name:'',
                schedule_type:'',
                date:'',
                id:''
            },
            addSchedulingWeightForm:{
                name:'',
                weight:'',
                date:'',
                id:''
            },
            displayShow:true,
        }
    },
    created(){
        this.apiCurrentStore()
        this.apiStoreAll()
    },
    mounted() {
        this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 160
    },
    methods:{
        // 门店
        apiStoreAll(){
            serve.fetchGet(api.crmScheduleStore,{}).then(data => {
                this.storeList = data.data
            }).catch((error)=>{
                this.$Message.error(error.response.data.message);
                this.storeList = CurrentStoreName
            })
        },
        // 当前账号门店
        apiCurrentStore(){
            serve.fetchGet(api.crmStoreGetCurrentStore,{}).then(res => {
                this.listQuery.store_id=res.data.id
                CurrentStoreId=res.data.id
                CurrentStoreName=[{id:res.data.id ,name: res.data.name}]
                if(window.agent_info){
                    this.uploadHeaders.Authorization=window.token_type+' '+window.token
                }  
                // if(Lockr.get("loginInfo")){
                //     this.uploadHeaders.Authorization=Lockr.get("loginInfo").token_type+' '+Lockr.get("loginInfo").access_token
                // }  
                // this.uploadHeaders.Authorization=window.token_type+' '+window.token
                this.getList()
            }).catch((error)=>{
                this.$Message.error(error.response.data.message);
            })
        },     
        // 获取列表
        getList(){ 
            this.tabLoading=true 
            let params={
                store_id:this.listQuery.store_id,
                month:this.dateFormat(this.listQuery.month,'yyyy-MM')
            }
            this.initData(params.month)
            serve.fetchGet(api.crmSchedule,params).then(res => {
                this.CurrentUploadParams=params
                console.log('this.CurrentUploadParams',this.CurrentUploadParams)
                var data=res.data;
                var arr=[];
                for(var i=0;i<data.length;i++){
                    var n=1
                    var obj={}
                    obj.user_name=data[i].user_name
                    obj.id=data[i].id
                    obj.weight=data[i].weight
                    for(var j=0;j<data[i].schedules.length;j++){
                        obj['schedule_type'+n]=data[i].schedules[j].schedule_type
                        // obj['date'+n]=data[i].schedules[j].date
                        n++;
                    }
                    arr.push(obj)
                }
              
                this.tabData=arr
                this.tabLoading=false
            }).catch((err=>{
                this.tabLoading=false
                this.$Message.error(error.response.data.message);
            })) 
        },
        // 清空筛选
        emptyFilter(){
            this.listQuery.month=CurrentDate
            this.listQuery.store_id=CurrentStoreId
            this.getList()
        },
        
        //获取当月天数
        getMonthDay(year,month) {
            var date = new Date(year,month,0);
            var day = date.getDate();
            return day;
        },
        //初始化表头日期数据
        initData(nowDate){
            var that=this;
            var dayArr=nowDate.split('-')
            var year =dayArr[0]
            var month =dayArr[1]
            var daylen=this.getMonthDay(year,month);
            // console.info('当月总天数'+month+'月',daylen)
            var arr=[{
                title: '姓名/日期',
                key: 'user_name',
                align:'center',
                width:100,
                fixed:'left'
            },
            {
                title: '分配权重',
                key: 'weight',
                align:'center',
                width:100,
                fixed:'left',
                render: (h, params) => {
                        return h('div',[
                            h('div',{
                                style:{
                                    'width':'100%',
                                    'height':'48px',
                                    'cursor':'pointer'
                                },
                                on: {
                                    click: () => {
                                        console.log('params',params)
                                        this.addSchedulingWeightForm.name=params.row.user_name
                                        this.addSchedulingWeightForm.weight=params.row.weight
                                        this.addSchedulingWeightForm.agent_id=params.row.id
                                        this.addSchedulingWeightForm.date=this.CurrentUploadParams.month
                                        setTimeout(()=> {
                                            that.$refs['weightInput'].focus();
                                        },200)
                                        this.showAddSchedulingWeight=true
                                    }
                                }
                            },params.row.weight)
                        ])
                }
            }]
            var dateArr=[]
            var week=["日","一","二","三","四","五","六"];
            for(let i=1;i<daylen+1;i++){
                var date = new Date(year,month-1,i);//默认是0开始
                var num = date.getDay();
                dateArr.push(that.dateFormat(date,'yyyy-MM-dd'))
                var obj={
                    title: week[num],
                    align:'center',
                    width:90,
                    children:[
                        {
                            title:that.dateFormat(date,'yyyy-MM-dd'),
                            align:'center',
                            width:90,
                            key:'schedule_type'+i,
                            render: (h, params) => {
                                const i = i
                                const column = params.column
                                const row = params.row;
                                const text = row[column.key];
                                return h('div',[
                                    h('div',{
                                        style:{
                                            'width':'100%',
                                            'height':'48px',
                                            'cursor':'pointer'
                                        },
                                        on: {
                                            click: () => {
                                                this.addSchedulingForm.name=row.user_name
                                                this.addSchedulingForm.id=row.id
                                                this.addSchedulingForm.date=column.title
                                                this.addSchedulingForm.schedule_type=text
                                                this.showAddScheduling=true
                                            }
                                        }
                                    },text)
                                ])
                            }
                        }
                    ]
                }
                arr.push(obj)
            }
            dateArr.unshift('ID','姓名NAME','分配权重WEIGHT')
            this.tabExcelArr=dateArr
            this.tabColumns=arr
        },
        // 修改排班
        editData(val){
            let params={
                schedule_type:val,
                date:this.addSchedulingForm.date
            }
            serve.fetchPatch(api.crmScheduleUpdate+"/"+this.addSchedulingForm.id,params).then(res => {
                this.$Message.success(res.data.message);
                this.getList()
                this.showAddScheduling=false
            }).catch((error)=>{
                this.$Message.error(error.response.data.message);
            })
            
        },
        //  分配权重
        editWeight(){
            let params={
                agent_id:this.addSchedulingWeightForm.agent_id,
                date:this.addSchedulingWeightForm.date,
                weight:this.addSchedulingWeightForm.weight
            }
            serve.fetchPatch(api.crmScheduleWeight,params).then(res => {
                this.$Message.success(res.data.message);
                this.getList()
                this.showAddSchedulingWeight=false
            }).catch((error)=>{
                this.$Message.error(error.response.data.message);
            })  
        },
        // 文件格式验证失败
         handleFormatError(file){
            console.log('文件格式验证失败时')
            this.$Notice.warning({
                title: '文件格式不正确',
                desc: '文件 ' + file.name + ' 格式不正确，请上传.xls,.xlsx文件。'
            })
        },
        // 文件上传成功
        handleSuccess(res,file){
            console.log('文件上传成功时')
            if(res.data.status_code === 201){
                // this.dialoLead = false
                this.$Message.success("数据导入成功！")
                this.getList()
                // this._getBookList()
                // this.$refs.upload.clearFiles()
            }else{
                this.$Message.error(res.data.success)
            }
        },
        // 文件上传失败
        handleError(error,file){
            console.log('文件上传失败时error',error)
            console.log('文件上传失败时file',file)
            this.$Modal.warning({
                width:'600',
                title: '数据导入有误',
                content: file.message
            });
        },
        // 下载当前Excel
        downloadCurrentExcel(){
            this.downloadLoading = true
            require.ensure([], () => {
                const { export_json_to_excel } = require('@/vendor/Export2Excel')
                var filterArr=['id','user_name','weight']
                if(this.tabData.length){
                    for(var i=1;i<this.tabExcelArr.length-1;i++){
                        filterArr.push('schedule_type'+i)
                    }
                }
                var title = this.storeList.map( item => {
                    if(item.id==this.CurrentUploadParams.store_id)return item.name
                }).join('').replace(/,/g,'');
                var month = this.CurrentUploadParams.month
                const tHeader = this.tabExcelArr
                const filterVal = filterArr
                const list = this.tabData
                const data = this.formatJson(filterVal, list)
                export_json_to_excel(tHeader, data, title+month+'母婴顾问排班')
                this.downloadLoading = false
            })
        },
        formatJson(filterVal, jsonData) {
            return jsonData.map(v => filterVal.map(j => v[j]))
        },
        //时间格式化
        dateFormat(time,type) {
            var date=new Date(time);
            var year=date.getFullYear();
            var month= date.getMonth()+1<10 ? "0"+(date.getMonth()+1) : date.getMonth()+1;
            var day=date.getDate()<10 ? "0"+date.getDate() : date.getDate();
            var hours=date.getHours()<10 ? "0"+date.getHours() : date.getHours();
            var minutes=date.getMinutes()<10 ? "0"+date.getMinutes() : date.getMinutes();
            var seconds=date.getSeconds()<10 ? "0"+date.getSeconds() : date.getSeconds();
            // 拼接
            if(type=='yyyy-MM-dd'){
                return year+"-"+month+"-"+day
            }else if (type=='yyyy-MM'){
                return year+"-"+month
            }
        }
    }
}

</script>
<style>
.mr-t-10{
    margin-top: 10px;
}
.content{

}
.search_bar{
    display: flex;
    justify-content: flex-start;
    flex-direction:row;
    flex-wrap: wrap;
}
.search_bar_item{
    /* text-align: center; */
    margin: 4px;
  }
.other_search_bar{
    display: flex;
    justify-content: flex-start;
    flex-direction:row;
    flex-wrap: wrap;
}
 
.table_wrap{
    margin: 12px 12px 12px 0px;
}
#tab .ivu-btn-icon-only {
    margin-left: 4px; 
    padding: 0px !important;
    font-size: 18px!important;
}
#tab .ivu-table-cell {
    white-space: pre-line!important;
    height: 100%!important;
    padding: 0;
}
#tab .ivu-drawer-header-inner {
    font-size: 20px!important;
}
.table_tip{
    margin: 0 0 10px 0px;
}
.demo-drawer-footer{
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
    border-top: 1px solid #e8e8e8;
    padding: 10px 16px;
    text-align: right;
    background: #fff;
    z-index: 10;
}
.user_info_wrap{
    display: flex;
    justify-content:space-between;
    flex-direction:row;
    flex-wrap: wrap;
    height:40px;
    color: #464c5b;
    font-weight: 600;
    font-size: 14px;
    line-height: 40px;
    background: #f8f8f9;
    margin:10px 0 ;
}
.vertical-center-modal{
    display: flex;
    align-items: center;
    justify-content: center;
}
.vertical-center-modal  .ivu-modal{
    top: 0;
}
.modal_title{
    text-align: center;
}
.modal_text{
    color:red;
    text-align:center;
    margin-bottom:16px
}
.user_info_text_wrap{
    height: 46px;
    padding-top: 10px;
    padding-left: 32px;
    /* line-height: 56px; */

    /* padding: 10px; */
}
#tab .ivu-table td, #tab .ivu-table th {
    height: 48px; 
    line-height: 48px;
}
.ivu-radio-group-button .ivu-radio-wrapper-checked {
    background: #2d8cf0;
    color: #fff;
    
    /* border-radius: 25px;
    border: none; */
}
.ivu-radio-group-button .ivu-radio-wrapper {
    margin: 0 6px;
}
.edit_scheduling_text{
    font-size: 14px;
    margin: 12px 0;
    font-weight: 500;
    color: #464c5b;
}
.opertionBtn{
    margin-bottom:20px;
    display:flex;
    display: -webkit-flex;
    align-items: center
}
.opertionBtn .item{
    margin-right: 5px
}
.mb-10{
    margin-bottom: 10px
}
</style>


// WEBPACK FOOTER //
// src/pages/Crm/CrmSetting/maternalConsultantSetting.vue